import { css } from 'lit';

export const styles = css`
  :host {
    display: block;
    padding: 12px;
    font-size: 20px;
    color: #5c6370;
    font-family: inherit;
    line-height: 1.6;
  }

  code {
    color: #e5c07b;
    font-size: 18px;
  }
`;
